import React from "react";
var __jsx = React.createElement;
import styled from 'styled-components';
import { BlobPicture, styles as S, breakpoint, brush, color } from '@bob/design-system';
import { toDataUrl } from '@bob/design-system/src/utils/svg';
import { RichText } from '@bob/rich-text';
export function Author(_ref) {
  var _article$author$profi;

  var article = _ref.article;
  var authorText = article.author.genre ? 'auteur' : 'autrice';
  return __jsx(Section, null, __jsx(BrushedText, null, "À propos de l'", authorText), __jsx(Wrapper, null, __jsx(BlobPicture, {
    size: 215,
    src: (_article$author$profi = article.author.profileImage) === null || _article$author$profi === void 0 ? void 0 : _article$author$profi.src
  }), __jsx("div", null, __jsx("div", null, __jsx(S.heading.Title3, null, article.author.name), __jsx(S.copy.Text4, null, article.author.quality)), __jsx(RichText, {
    document: article.author.signature.json,
    links: article.author.signature.links,
    renderNode: {
      Paragraph: S.copy.Text1
    }
  }))));
}
var Wrapper = styled.div.withConfig({
  displayName: "Author__Wrapper",
  componentId: "sc-1hrfgox-0"
})(["display:flex;flex-direction:column;@media screen and (", "){flex-direction:row;align-items:center;justify-content:space-between;max-width:700px;margin:10px auto 0px;}"], breakpoint.TABLET);
var Section = styled.section.withConfig({
  displayName: "Author__Section",
  componentId: "sc-1hrfgox-1"
})(["", "{margin:0px auto 18px;@media screen and (", "){margin-right:45px;}}", "{font-size:35px;line-height:48px;}", "{margin:20px 0px 30px;opacity:0.8;@media screen and (", "){max-width:296px;}}@media screen and (", "){margin-bottom:30px;}"], BlobPicture, breakpoint.TABLET, S.heading.Title3, S.copy.Text1, breakpoint.TABLET, breakpoint.TABLET);
var brushBackgroundText = toDataUrl(brush.full.FullBrush3, {
  width: 280,
  height: 80,
  fill: color.YELLOW
});
var BrushedText = styled.div.withConfig({
  displayName: "Author__BrushedText",
  componentId: "sc-1hrfgox-2"
})(["display:flex;align-items:center;justify-content:center;margin-top:65px;height:80px;font-weight:bold;font-size:24px;background-repeat:no-repeat;background-position:center;background-image:url('", "');"], brushBackgroundText);